import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Last active chat session id, persisted so a reload restores the same conversation. Only the
// shell routes (/chat/{id}) and a carried `?chat=` name the session in the URL and skip this.
//
// Stored with its `orgId` and only returned when read under the same org: a restored cross-tenant
// id 404s, and the error path auto-assumes its tenant (switching back). Accessed imperatively
// (get/set), so it's a plain persisted store, not a hook.
type LastSessionState = {
  orgId: string | null;
  sessionId: string | null;
  setSession: (sessionId: string | null, orgId: string) => void;
};

const useStore = create<LastSessionState>()(
  persist(
    set => ({
      orgId: null,
      sessionId: null,
      setSession: (sessionId, orgId) =>
        set(sessionId === null ? { orgId: null, sessionId: null } : { orgId, sessionId }),
    }),
    { name: 'percy.chat-widget-last-session', partialize: ({ orgId, sessionId }) => ({ orgId, sessionId }) },
  ),
);

export const setLastSessionId = (id: string | null, orgId: string) => {
  useStore.getState().setSession(id, orgId);
};

export const getLastSessionId = (orgId: string): string | null => {
  const { orgId: storedOrgId, sessionId } = useStore.getState();
  return sessionId && storedOrgId === orgId ? sessionId : null;
};
